const comMain = () => {
  if (document.querySelector("section#jsComSecMain") !== null) {



    let sW = window.innerWidth;

    let secMain = document.querySelector('#jsComSecMain');

    let copyWrap = secMain.querySelector('.js-copy-wrap');

    let imgWrap = secMain.querySelector('.js-img-wrap');


    // let st2
    // if (sW > 768) {
    //   st2 = 2400
    // } else {
    //   st2 = 1600
    // }

    setTimeout(() => {
      copyWrap.classList.add('is-act')
    }, 800);
    setTimeout(() => {
      // secMain.classList.add('is-act')
      imgWrap.classList.add('is-act')
    }, 2000);


    ScrollTrigger.create({
      trigger: '#jsComSecMain',
      start: '20px 0%',
      end: '100% 0%',
      toggleClass: {
        targets: "#jsComSecMain",
        className: "is-act"
      },
      // markers: true,
    });



  }
}
export default comMain;